import Navbar from "../../../component/navbar";
import Footer from "../../../component/footer";
import { useNavigate } from "react-router-dom";
import Modal from "../../../component/modal";
import { useState } from "react";
export default function TORJA() {
  const navigate = useNavigate();
  const [titleModal, setTitleModal] = useState("");
  const [showModal, setShowModal] = useState(false);

  const showModalPreview = (data) => {
    setTitleModal(data);
    setShowModal(true); // Show modal
  };

  const closeModal = () => setShowModal(false); // Close modal

  const menuButton = [
    {
      link: "/TORJA/Flow-TOR.pdf",
      img: "https://img.icons8.com/?size=100&id=8pY9EIAJAH1X&format=png&color=000000",
      title: "คู่มือ TOR-JA",
    },
    {
      link: "https://mis.cmu.ac.th/cmumis/",
      img: "https://img.icons8.com/?size=100&id=SLVrkHfubd7p&format=png&color=000000",
      title: "เข้าระบบ TOR-JA",
    },
    {
      link: "/TORJA/บันทึกส่ง-JA_ผบ.หน.doc",
      img: "https://img.icons8.com/?size=100&id=N0kmaW7GXn6L&format=png&color=000000",
      title: "บันทึกขอส่ง JA",
    },
    {
      link: "/TORJA/TORJA_อบรมคณาจารย์-วัน-13-มิ.ย.-67-1.pdf",
      img: "https://img.icons8.com/?size=100&id=MXaFu8IZMLE3&format=png&color=000000",
      title: "TOR-JA สายคณาจารย์",
    },
  ];

  const menuButton2 = [
    {
      link: "modalManual",
      title: "แจ้งสัดส่วนการประเมินผลการปฏิบัติงานของพนักงานมหาวิทยาลัย",
    },
    {
      link: "modalManual",
      title: "คู่มือระบบการประเมินผลการปฏิบัติงาน CMU MIS",
    },
    {
      link: "https://hr.oop.cmu.ac.th/menu/pa/pa-2",
      title: "กฏระเบียบ และประกาศการประเมินผลการปฏิบัติงาน",
    },
    {
      link: "modalManual",
      title: "วิธีการประเมินผลการปฏิบัติงาน พนักงานมหาวิทยาลัยส่วนงาน",
    },
  ];

  const menuButton3 = [
    {
      link: "/MIS/CMU-MIS-performance-appraisal.pdf",
      img: "https://img.icons8.com/?size=100&id=JWpT8cAn8G0V&format=png&color=000000",
      title: "ระบบประเมินผลการปฏบัติงาน",
    },
    {
      link: "/MIS/performance-appraisal-admin.pdf",
      img: "https://img.icons8.com/?size=100&id=JWpT8cAn8G0V&format=png&color=000000",
      title:
        "คู่มือการใช้งานระบบสารสนเทศด้านการประเมินผลการปฏิบัติงาน (CMU-MIS)",
    },
    {
      link: "/MIS/performance-appraisal-committee.pdf",
      img: "https://img.icons8.com/?size=100&id=o9lx5OqxQuEH&format=png&color=000000",
      title: `วิธีการใช้งาน<span>(สำหรับผู้มีสิทธิ์ดูผล)</span>การประเมินการปฏิบัติงาน`,
    },
    {
      link: "/MIS/performance-appraisal.pdf",
      img: "https://img.icons8.com/?size=100&id=o9lx5OqxQuEH&format=png&color=000000",
      title: "วิธีการใช้งาน<span>(สำหรับกรรมการ)</span>ประเมินผลการปฏิบัติงาน",
    },
  ];

  const showModalManual = () => {
    return (
      <>
        <div className="flex flex-shrink-0 items-center justify-center space-x-6">
          {menuButton3.map((item, index) => (
            <div
              key={index}
              onClick={() => {
                window.open(item.link, "_blank");
              }}
              className="relative group cursor-pointer"
            >
              <div className="flex flex-col justify-center items-center text-center gap-y-4">
                <div className="w-20 h-20">
                  <img src={item.img} className="object-cover" alt="" />
                </div>
                <span
                  className="px-2 font-[500] text-[#9e76b4]  md:text-lg mb-1"
                  dangerouslySetInnerHTML={{
                    __html: `${item.title.replace(
                      "<span>",
                      `<span class="text-red-500">`
                    )}`,
                  }}
                ></span>
              </div>
              <div className="absolute bottom-0 left-1/2 w-0 h-[2px] bg-[#9e76b4] transition-all duration-500 transform -translate-x-1/2 group-hover:w-full"></div>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <>
      <Navbar />
      <div className="w-full h-screen relative">
        <div className="container w-full md:max-w-5xl mx-auto my-5 md:my-10 flex flex-col justify-center gap-y-10 ">
          <div className="w-full rounded-2xl overflow-hidden">
            <img
              src="https://w1.med.cmu.ac.th/personnel/files/2024/01/Space-Race-Google-Classroom-Header-8-1024x409.png"
              className="object-cover"
              alt=""
            />
          </div>
          {/* Button menu */}
          <div className="flex flex-col pb-[200px] gap-y-10">
            <div className="w-full">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                {menuButton.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      const supportedExtensions = [
                        ".pdf",
                        ".docx",
                        ".doc",
                        ".xlsx",
                        ".xls",
                      ];
                      const isSupported = supportedExtensions.some((ext) =>
                        item.link.endsWith(ext)
                      );
                      const isExternalLink = item.link.startsWith("https://");

                      if (isSupported) {
                        // เปิดไฟล์ที่รองรับในแท็บใหม่
                        window.open(item.link, "_blank");
                      } else if (isExternalLink) {
                        // หากเป็นลิงก์ภายนอก (มี https://) ให้เปิดในแท็บใหม่
                        window.open(item.link, "_blank");
                      } else {
                        // หากไม่เข้าเงื่อนไขด้านบน ให้ใช้ navigate
                        navigate(item.link);
                      }
                    }}
                    className="relative group cursor-pointer"
                  >
                    <div className="flex flex-col items-center justify-center space-y-3 drop-shadow-md">
                      <div className="w-20 h-20">
                        <img src={item.img} className="object-cover" alt="" />
                      </div>
                      <span className="px-2 font-bold text-[#9e76b4] border-b-2 border-[#9e76b4] md:text-lg mb-2">
                        {item.title}
                      </span>
                    </div>
                    <div className="absolute bottom-0 left-1/2 w-0 h-[2px] bg-[#9e76b4] transition-all duration-500 transform -translate-x-1/2 group-hover:w-full"></div>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-full">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 ">
                {menuButton2.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      const supportedExtensions = [
                        ".pdf",
                        ".docx",
                        ".doc",
                        ".xlsx",
                        ".xls",
                      ];
                      const isSupported = supportedExtensions.some((ext) =>
                        item.link.endsWith(ext)
                      );
                      const isExternalLink = item.link.startsWith("https://");

                      if (isSupported) {
                        // เปิดไฟล์ที่รองรับในแท็บใหม่
                        window.open(item.link, "_blank");
                      } else if (isExternalLink) {
                        // หากเป็นลิงก์ภายนอก (มี https://) ให้เปิดในแท็บใหม่
                        window.open(item.link, "_blank");
                      } else if (item.link == "modalManual") {
                        // หากไม่เข้าเงื่อนไขด้านบน ให้ใช้ navigate
                        showModalPreview(item.title, "ยังไม่พร้อมใช้งาน");
                      } else {
                        navigate(item.link);
                      }
                    }}
                    className="flex flex-col items-center justify-center bg-gray-100 rounded-xl space-y-3 
                    drop-shadow-md py-5 px-4 text-center text-[#9e76b4] cursor-pointer transition-colors duration-300 ease-in-out hover:bg-[#9e76b4] hover:text-white"
                  >
                    <p className="text-lg font-[500]">{item.title}</p>
                  </div>
                ))}
              </div>
            </div>
            <Modal
              show={showModal}
              onClose={closeModal}
              size="max-w-7xl"
              title={titleModal}
            >
              {titleModal == "คู่มือระบบการประเมินผลการปฏิบัติงาน CMU MIS"
                ? showModalManual()
                : "อยู่ระหว่างการตรวจสอบข้อมูล"}
            </Modal>
          </div>
          {/* Button menu */}
        </div>
      </div>
      <Footer />
    </>
  );
}
